import styled from 'styled-components'
import * as BaseStyles from '../BaseStyles'

import exitIcon from '../../Icons/Normal/Dark/exit-icon.png'
import saveIcon from '../../Icons/Normal/Dark/save-icon.png'
import editIcon from '../../Icons/Normal/Dark/edit-icon.png'
import backIcon from '../../Icons/Normal/Dark/back-icon.png'
import addIcon from '../../Icons/Normal/Dark/add-icon.png'

import hoverExitIcon from '../../Icons/Hover/exit-icon.png'
import hoverSaveIcon from '../../Icons/Hover/save-icon.png'
import hoverEditIcon from '../../Icons/Hover/edit-icon.png'
import hoverBackIcon from '../../Icons/Hover/back-icon.png'
import hoverAddIcon from '../../Icons/Hover/add-icon.png'

import logoIcon from '../../Icons/Logos/qf-logo.png'

export const NavDiv = styled(BaseStyles.Div)`
    overflow: auto;
    height: 5rem;
    padding: 0rem 2rem;
`

export const NavDivContainer = styled(BaseStyles.Div)`
    margin: 0rem auto;
    min-width: 20rem;
    max-width: 140rem;
    height: 100%;
`

export const NavItem = styled(BaseStyles.Div)`
    display: block;
    color: white;
    background-color: transparent;
    text-align: center;
    font-size: 1.3rem;
`

export const NavList = styled.ul`
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
`

export const LeftNavList = styled(NavList)`
    float: left;
    height: 5rem;
`

export const MidNavList = styled(NavList)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`

export const RightNavList = styled(NavList)`
    float: right;
    height: 5rem;
`

export const NavListItem = styled.li`
    float: left;
    padding: 1.25rem 0rem;
`

export const NavButton = styled.button`
    display: block;
    background-color: transparent;
    text-align: center;
    outline-style: none;
    cursor: pointer;
`

export const TitleIconButton = styled(BaseStyles.IconButton)`
    margin-right: 0.5rem;
    padding: 0;
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${logoIcon});
`

export const TitleButton = styled(NavButton)`
    font-size: 2.5rem;
    line-height: 2.5rem;
    border: none;
    font-weight: bold;
    font-family: "Helvetica Neue";
    padding: 0rem;
    margin: 0rem;
    height: 2.5rem;

  align-items: center; 
`

export const HoverTitleButton = styled(TitleButton)`
    &:hover {
        color: #4267B2;
    }
`

export const ActionButton = styled(NavButton)`
    font-size: 1.5rem;
    border: none;
    &:hover{
        color: #4267B2;
    }
`

export const ModeText = styled.h1`  
    font-size: 2rem;
    font-weight: normal;
`

export const ExitButton = styled(BaseStyles.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${exitIcon});
    &:hover{
        background-image: url(${hoverExitIcon});
    }
`

export const BackButton = styled(BaseStyles.IconButton)`
    height: 2rem;
    background-image: url(${backIcon});
    &:hover{
        background-image: url(${hoverBackIcon});
    }
`

export const SaveButton = styled(BaseStyles.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${saveIcon});
    &:hover{
        background-image: url(${hoverSaveIcon});
    }
`

export const EditButton = styled(BaseStyles.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${editIcon});
    &:hover{
        background-image: url(${hoverEditIcon});
    }
`

export const AddButton = styled(BaseStyles.IconButton)`
    width: 2.5rem;
    height: 2.5rem;
    background-image: url(${addIcon});
    &:hover{
        background-image: url(${hoverAddIcon});
    }
`

